module.exports = __webpack_public_path__ + "img/back2.002c802f.jpg";